import { Grid2, Box } from "@mui/material";
import React from "react";
import ContentCard from "../../../../components/Content/ContentCard";
import LinkBox from "../../../../components/Content/LinkBox";
import {
  INTRO_HTML,
  MIDDLE_HTML,
  STUDY_GROUP_TITLE,
  STUDY_GROUP_AUTHOR,
  LINK_BOX_TITLE,
  LINK_BOX_URL,
  ACIM_STUDY_LINK,
  TAB_LESSONS,
  miraclesData,
} from "./MainPage.constants";
import {
  IntroText,
  GridContainer,
  MiddleParagraph,
  StudySectionStack,
  StudyImage,
  StudyTitle,
  StudyLinkStack,
} from "./MainPage.styles";
import ACIM_STUDY_IMAGE from "../../../../assets/images/acim-study.png";

const MainPage = ({ setCompState }) => {
  const handleCardClick = (item) => {
    if (item.type === "clickable") {
      setCompState(TAB_LESSONS);
    } else {
      window.open(item.link, "_blank");
    }
  };

  const handleStudyImageClick = () => {
    window.open(ACIM_STUDY_LINK, "_blank");
  };

  return (
    <>
      <IntroText dangerouslySetInnerHTML={{ __html: INTRO_HTML }} />

      <GridContainer container spacing={2}>
        {miraclesData.map((item, index) => (
          <React.Fragment key={item.id}>
            <ContentCard
              item={item}
              size={item.size || 4}
              height="150px"
              clickable={!!(item.link || item.type === "clickable")}
              onClick={() => handleCardClick(item)}
            />

            {index === 0 && (
              <Grid2 item size={{ xs: 12 }}>
                <MiddleParagraph
                  dangerouslySetInnerHTML={{ __html: MIDDLE_HTML }}
                />
              </Grid2>
            )}
          </React.Fragment>
        ))}

        <StudySectionStack>
          <StudyImage
            src={ACIM_STUDY_IMAGE}
            alt="ACIM Study"
            onClick={handleStudyImageClick}
          />

          <StudyLinkStack spacing={1}>
            <StudyTitle>
              {STUDY_GROUP_TITLE}{" "}
              <StudyTitle component="span">{STUDY_GROUP_AUTHOR}</StudyTitle>
            </StudyTitle>
            <Box sx={{ width: "100%" }}>
              <LinkBox title={LINK_BOX_TITLE} link={LINK_BOX_URL} />
            </Box>
          </StudyLinkStack>
        </StudySectionStack>
      </GridContainer>
    </>
  );
};

export default MainPage;
